export const UPDATE_ODDS = 'preferences/UPDATE_ODDS'
export const UPDATE_AMOUNT = 'preferences/UPDATE_AMOUNT'
export const UPDATE_COLUMNS = 'preferences/UPDATE_COLUMNS'
export const UPDATE_LEAGUES = 'preferences/UPDATE_LEAGUES'
export const UPDATE_LOADED = 'preferences/UPDATE_LOADED'
export const UPDATE_PARTNER = 'preferences/UPDATE_PARTNER'
export const UPDATE_CLICKS_E_D = 'preferences/UPDATE_CLICKS_E_D'
export const UPDATE_PENDING_ACTION_GROUP = 'preferences/UPDATE_PENDING_ACTION_GROUP'